module.exports = __webpack_public_path__ + "static/media/Avatar5b.9aaccfb7.png";